import { makeStyles } from '../../../styles';
export const useStyles = makeStyles(() => ({
    root: {
        '&.MuiList-padding': {
            padding: 0,
        },
    },
}));
//# sourceMappingURL=List.styles.js.map